import type { FilterEntitySourceId } from "building-types/buildingGraphFilter/entitySource";
import type { EntityFilterSource } from "../entityFilterSourceTypes";
import { faceEdgeSource } from "./faceEdgeSource";
import { faceNodeSource } from "./faceNodeSource";
import { planarTopologyFaceSource } from "./planarTopologyFaceSource";
import { volumeEdgeSource } from "./volumeEdgeSource";
import { volumeNodeSource } from "./volumeNodeSource";
import { wallPlaneSource } from "./wallPlaneSource";

export const ENTITY_FILTER_SOURCES = Object.freeze({
  WALL_PLANE: wallPlaneSource,
  FACE_NODE: faceNodeSource,
  FACE_EDGE: faceEdgeSource,
  VOLUME_NODE: volumeNodeSource,
  VOLUME_EDGE: volumeEdgeSource,
  PLANAR_TOPOLOGY_FACE: planarTopologyFaceSource,
}) satisfies { [K in FilterEntitySourceId]: EntityFilterSource<K> };
